import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'fcom-plain-header-area',
  templateUrl: './plain-header-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PlainHeaderAreaComponent {
  title = input.required<string>();
  subtitle = input<string>();
  headingClass = input('nordic-blue-900-text text-icon-primary');
}
